import { render, staticRenderFns } from "./DetailContentComponent.vue?vue&type=template&id=1557b262&scoped=true"
import script from "./DetailContentComponent.vue?vue&type=script&lang=js"
export * from "./DetailContentComponent.vue?vue&type=script&lang=js"
import style0 from "./DetailContentComponent.vue?vue&type=style&index=0&id=1557b262&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1557b262",
  null
  
)

export default component.exports